module.exports = __webpack_public_path__ + "static/img/project_person2.3c1d968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project_person2.png
// module id = 5ZwE
// module chunks = 1